export default [
    {
        path: '/payouts',
        name: 'Payouts',
        meta: {
            requiresAuth: true,
            allowRoles: ['SUPER', 'OWNER', 'ADMIN', 'MANAGER', 'FINANCE'],
            denyRoles: null,
            title: 'Payouts',
        },
        components: {
            default: () => import('@views/payouts/PayoutsIndex.vue'),
        },
    },
];
